// src/components/landing/LandingPage.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const WHATSAPP = 'https://wa.me/5511911470957';

/* ─── Ícones ─────────────────────────────────────────────────────────────── */
const ZapIcon = () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>);
const RefreshIcon = () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>);
const UsersIcon = () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>);
const LinkIcon = () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>);
const ChartIcon = () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>);
const GlobeIcon = () => (<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>);
const CheckIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>);
const WhatsAppIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/></svg>);
const StarIcon = () => (<svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" stroke="none"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>);
const ArrowRightIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>);

/* ─── Dados ───────────────────────────────────────────────────────────────── */
const FEATURES = [
    { icon: <ZapIcon />, title: 'Automação inteligente', desc: 'Tarefas avançam automaticamente conforme o horário programado, sem precisar de intervenção manual.', color: '#f59e0b', bg: 'rgba(245,158,11,0.08)', border: 'rgba(245,158,11,0.2)' },
    { icon: <RefreshIcon />, title: 'Atualização em tempo real', desc: 'Todas as telas atualizam a cada 15 segundos automaticamente. Sem F5, sem atraso.', color: '#2CCB90', bg: 'rgba(44,203,144,0.08)', border: 'rgba(44,203,144,0.2)' },
    { icon: <UsersIcon />, title: 'Múltiplos perfis de acesso', desc: 'Diretor, operacional, palestrante e público — cada um vê exatamente o que precisa.', color: '#2DB8E1', bg: 'rgba(45,184,225,0.08)', border: 'rgba(45,184,225,0.2)' },
    { icon: <LinkIcon />, title: 'Link permanente por cliente', desc: 'Um único link por organização. Compartilhe uma vez e ele sempre mostrará o evento ao vivo.', color: '#7c3aed', bg: 'rgba(124,58,237,0.08)', border: 'rgba(124,58,237,0.2)' },
    { icon: <ChartIcon />, title: 'Dashboard executivo', desc: 'O diretor acompanha progresso, métricas e estatísticas do evento em tempo real.', color: '#ef4444', bg: 'rgba(239,68,68,0.08)', border: 'rgba(239,68,68,0.2)' },
    { icon: <GlobeIcon />, title: 'Programação pública', desc: 'Participantes acessam a programação completa sem precisar de cadastro ou login.', color: '#0891b2', bg: 'rgba(8,145,178,0.08)', border: 'rgba(8,145,178,0.2)' },
];

const PLANS = [
    {
        id: 'avulso',
        name: '1 Mês',
        badge: null,
        price: 297,
        period: 'pagamento único',
        saving: null,
        highlight: false,
        items: [
            'Acesso completo por 30 dias',
            'Todos os perfis de acesso',
            'Eventos ilimitados',
            'Link permanente por cliente',
            'Suporte via WhatsApp',
        ],
    },
    {
        id: 'mensal',
        name: 'Mensal',
        badge: null,
        price: 197,
        period: 'por mês',
        saving: 'Economize R$100/mês vs avulso',
        highlight: false,
        items: [
            'Tudo do plano 1 Mês',
            'Renovação automática mensal',
            'Cancele quando quiser',
            'Histórico completo de eventos',
            'Suporte prioritário',
        ],
    },
    {
        id: 'anual',
        name: 'Anual',
        badge: 'Mais vantajoso',
        price: 147,
        period: 'por mês · R$1.764/ano',
        saving: 'Economize R$600/ano vs mensal',
        highlight: true,
        items: [
            'Tudo do plano Mensal',
            'Melhor custo por mês',
            'Economia de R$600 no ano',
            'Acesso a novas funcionalidades',
            'Suporte VIP com prioridade máxima',
        ],
    },
];

const STEPS = [
    { num: '01', title: 'Crie seu evento', desc: 'Cadastre o evento, defina a programação com horários e responsáveis.' },
    { num: '02', title: 'Compartilhe o link', desc: 'Um link permanente gerado para sua organização. Compartilhe uma única vez.' },
    { num: '03', title: 'Execute com precisão', desc: 'O sistema avança automaticamente, mantendo todos informados em tempo real.' },
];

/* ─── Componente ──────────────────────────────────────────────────────────── */
const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

const LandingPage = () => {
    const navigate = useNavigate();
    const [mounted, setMounted] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const [loadingPlano, setLoadingPlano] = useState(null);

    useEffect(() => {
        const t = setTimeout(() => setMounted(true), 80);
        const onScroll = () => setScrolled(window.scrollY > 20);
        window.addEventListener('scroll', onScroll);
        return () => { clearTimeout(t); window.removeEventListener('scroll', onScroll); };
    }, []);

    const handleAssinar = async (planoId) => {
        setLoadingPlano(planoId);
        try {
            const resp = await fetch(`${SUPABASE_URL}/functions/v1/create-checkout-session`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${SUPABASE_ANON_KEY}` },
                body: JSON.stringify({ plano: planoId }),
            });
            const { url, error } = await resp.json();
            if (error) throw new Error(error);
            window.location.href = url;
        } catch {
            window.open(WHATSAPP, '_blank');
        } finally {
            setLoadingPlano(null);
        }
    };

    return (
        <>
            <style>{`
                * { box-sizing: border-box; margin: 0; padding: 0; }
                html { scroll-behavior: smooth; }

                @keyframes lp-fadein  { from{opacity:0;transform:translateY(24px);} to{opacity:1;transform:translateY(0);} }
                @keyframes lp-float   { 0%,100%{transform:translateY(0);} 50%{transform:translateY(-10px);} }
                @keyframes lp-pulse   { 0%,100%{opacity:1;} 50%{opacity:0.5;} }
                @keyframes lp-aurora1 { 0%,100%{transform:translate(0,0) scale(1);} 50%{transform:translate(60px,-40px) scale(1.08);} }
                @keyframes lp-aurora2 { 0%,100%{transform:translate(0,0) scale(1);} 50%{transform:translate(-60px,50px) scale(0.93);} }
                @keyframes lp-shine   { from{left:-100%;} to{left:200%;} }

                .lp-btn-primary {
                    display:inline-flex; align-items:center; gap:8px;
                    padding:14px 28px; border-radius:14px; border:none;
                    background:linear-gradient(135deg,#2CCB90,#2DB8E1);
                    color:#fff; font-size:15px; font-weight:700; cursor:pointer;
                    font-family:inherit; transition:all 0.25s;
                    box-shadow:0 8px 24px rgba(44,203,144,0.35);
                    position:relative; overflow:hidden;
                }
                .lp-btn-primary::after {
                    content:''; position:absolute; top:0; left:-100%;
                    width:60%; height:100%;
                    background:linear-gradient(90deg,transparent,rgba(255,255,255,0.2),transparent);
                    transition:none;
                }
                .lp-btn-primary:hover { transform:translateY(-2px); box-shadow:0 12px 32px rgba(44,203,144,0.45); }
                .lp-btn-primary:hover::after { animation:lp-shine 0.6s ease; }

                .lp-btn-ghost {
                    display:inline-flex; align-items:center; gap:8px;
                    padding:12px 24px; border-radius:12px;
                    border:1px solid rgba(255,255,255,0.25);
                    background:rgba(255,255,255,0.1);
                    color:#fff; font-size:14px; font-weight:600; cursor:pointer;
                    font-family:inherit; transition:all 0.2s; backdrop-filter:blur(8px);
                }
                .lp-btn-ghost:hover { background:rgba(255,255,255,0.18); border-color:rgba(255,255,255,0.4); }

                .lp-feature-card {
                    background:#fff; border:1px solid #e8edf2; border-radius:20px;
                    padding:28px; transition:all 0.25s;
                    box-shadow:0 1px 4px rgba(0,0,0,0.04);
                }
                .lp-feature-card:hover { transform:translateY(-4px); box-shadow:0 12px 32px rgba(0,0,0,0.08); border-color:#cbd5e1; }

                .lp-plan-card {
                    background:#fff; border:1px solid #e2e8f0; border-radius:24px;
                    padding:32px 28px; display:flex; flex-direction:column;
                    transition:all 0.25s; position:relative; overflow:hidden;
                }
                .lp-plan-card:hover { transform:translateY(-4px); box-shadow:0 16px 48px rgba(0,0,0,0.1); }
                .lp-plan-card.highlight {
                    border-color:transparent;
                    background:linear-gradient(#fff,#fff) padding-box,
                               linear-gradient(135deg,#2CCB90,#2DB8E1) border-box;
                    border:2px solid transparent;
                    box-shadow:0 8px 32px rgba(44,203,144,0.2);
                }
                .lp-plan-card.highlight:hover { box-shadow:0 20px 56px rgba(44,203,144,0.3); }

                .lp-nav-link {
                    font-size:14px; font-weight:500; color:#64748b; cursor:pointer;
                    text-decoration:none; transition:color 0.15s; background:none; border:none; font-family:inherit;
                }
                .lp-nav-link:hover { color:#0f172a; }

                @media(max-width:768px) {
                    .lp-features-grid { grid-template-columns: 1fr !important; }
                    .lp-plans-grid { grid-template-columns: 1fr !important; }
                    .lp-steps-grid { grid-template-columns: 1fr !important; }
                    .lp-hero-btns { flex-direction:column !important; align-items:stretch !important; }
                    .lp-nav-links { display:none !important; }
                }
                @media(max-width:480px) {
                    .lp-features-grid { grid-template-columns: 1fr !important; }
                }
            `}</style>

            <div style={{ minHeight:'100vh', background:'#f8fffe', fontFamily:"'Inter',-apple-system,BlinkMacSystemFont,sans-serif", overflowX:'hidden' }}>

                {/* ── NAVBAR ────────────────────────────────────────────── */}
                <header style={{
                    position:'fixed', top:0, left:0, right:0, zIndex:100,
                    background: scrolled ? 'rgba(255,255,255,0.95)' : 'transparent',
                    backdropFilter: scrolled ? 'blur(20px)' : 'none',
                    borderBottom: scrolled ? '1px solid #e2e8f0' : '1px solid transparent',
                    transition:'all 0.3s',
                }}>
                    <div style={{ maxWidth:'1200px', margin:'0 auto', padding:'0 24px', height:'68px', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                        <div style={{ display:'inline-flex', alignItems:'center', background:'#fff', borderRadius:'10px', padding:'6px 16px', boxShadow:'0 1px 8px rgba(0,0,0,0.08)', border:'1px solid #e2e8f0' }}>
                            <img src="/logo-horizontal.png" alt="Evlo" style={{ height:'26px', objectFit:'contain' }} onError={e => { e.target.style.display='none'; e.target.parentNode.innerHTML='<span style="font-size:20px;font-weight:800;color:#0E2C52;letter-spacing:-0.03em">evlo</span>'; }} />
                        </div>

                        <div className="lp-nav-links" style={{ display:'flex', alignItems:'center', gap:'28px' }}>
                            <a href="#funcionalidades" className="lp-nav-link">Funcionalidades</a>
                            <a href="#como-funciona" className="lp-nav-link">Como funciona</a>
                            <a href="#planos" className="lp-nav-link">Planos</a>
                        </div>

                        <div style={{ display:'flex', gap:'10px', alignItems:'center' }}>
                            <button onClick={() => navigate('/login')} style={{ padding:'8px 18px', borderRadius:'10px', border:'1px solid #e2e8f0', background:'#fff', color:'#0f172a', fontSize:'14px', fontWeight:600, cursor:'pointer', fontFamily:'inherit', transition:'all 0.15s' }}
                                onMouseEnter={e => e.currentTarget.style.background='#f8fafc'}
                                onMouseLeave={e => e.currentTarget.style.background='#fff'}>
                                Entrar
                            </button>
                            <a href={WHATSAPP} target="_blank" rel="noopener noreferrer" style={{ display:'inline-flex', alignItems:'center', gap:'7px', padding:'9px 18px', borderRadius:'10px', background:'linear-gradient(135deg,#2CCB90,#2DB8E1)', color:'#fff', fontSize:'14px', fontWeight:700, textDecoration:'none', transition:'all 0.2s', boxShadow:'0 4px 12px rgba(44,203,144,0.3)' }}
                                onMouseEnter={e => { e.currentTarget.style.transform='translateY(-1px)'; e.currentTarget.style.boxShadow='0 6px 18px rgba(44,203,144,0.4)'; }}
                                onMouseLeave={e => { e.currentTarget.style.transform=''; e.currentTarget.style.boxShadow='0 4px 12px rgba(44,203,144,0.3)'; }}>
                                <WhatsAppIcon /> Contratar
                            </a>
                        </div>
                    </div>
                </header>

                {/* ── HERO ──────────────────────────────────────────────── */}
                <section style={{ position:'relative', minHeight:'100vh', display:'flex', alignItems:'center', background:'linear-gradient(160deg, #0E2C52 0%, #0d3a6e 50%, #0a4a5e 100%)', overflow:'hidden', paddingTop:'68px' }}>

                    {/* Aurora */}
                    <div style={{ position:'absolute', inset:0, pointerEvents:'none' }}>
                        <div style={{ position:'absolute', top:'-10%', left:'-5%', width:'700px', height:'700px', borderRadius:'50%', background:'radial-gradient(circle, rgba(44,203,144,0.18) 0%, transparent 65%)', filter:'blur(80px)', animation:'lp-aurora1 18s ease-in-out infinite' }} />
                        <div style={{ position:'absolute', bottom:'-15%', right:'-5%', width:'800px', height:'800px', borderRadius:'50%', background:'radial-gradient(circle, rgba(45,184,225,0.14) 0%, transparent 65%)', filter:'blur(80px)', animation:'lp-aurora2 22s ease-in-out infinite' }} />
                        <div style={{ position:'absolute', top:'30%', right:'10%', width:'400px', height:'400px', borderRadius:'50%', background:'radial-gradient(circle, rgba(124,58,237,0.1) 0%, transparent 65%)', filter:'blur(60px)' }} />
                    </div>

                    {/* Grid pattern */}
                    <div style={{ position:'absolute', inset:0, backgroundImage:'linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)', backgroundSize:'60px 60px', pointerEvents:'none' }} />

                    <div style={{ position:'relative', zIndex:1, maxWidth:'1200px', margin:'0 auto', padding:'80px 24px', textAlign:'center' }}>

                        {/* Badge */}
                        <div style={{ opacity: mounted?1:0, transform: mounted?'translateY(0)':'translateY(20px)', transition:'all 0.6s ease', marginBottom:'28px' }}>
                            <span style={{ display:'inline-flex', alignItems:'center', gap:'8px', padding:'6px 16px', borderRadius:'100px', background:'rgba(44,203,144,0.15)', border:'1px solid rgba(44,203,144,0.3)', color:'#2CCB90', fontSize:'13px', fontWeight:700, letterSpacing:'0.06em', textTransform:'uppercase' }}>
                                <span style={{ width:'7px', height:'7px', borderRadius:'50%', background:'#2CCB90', animation:'lp-pulse 1.5s ease-in-out infinite', display:'inline-block', flexShrink:0 }} />
                                Gestão de Eventos Profissional
                            </span>
                        </div>

                        {/* Headline */}
                        <h1 style={{ opacity: mounted?1:0, transform: mounted?'translateY(0)':'translateY(24px)', transition:'all 0.6s ease 0.1s', margin:'0 0 24px', fontSize:'clamp(36px,6vw,72px)', fontWeight:900, letterSpacing:'-0.04em', lineHeight:1.08, color:'#fff' }}>
                            Execute eventos com{' '}
                            <span style={{ background:'linear-gradient(90deg,#2CCB90,#2DB8E1)', WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent' }}>
                                precisão
                            </span>{' '}
                            e em tempo real
                        </h1>

                        {/* Subtitle */}
                        <p style={{ opacity: mounted?1:0, transform: mounted?'translateY(0)':'translateY(24px)', transition:'all 0.6s ease 0.2s', margin:'0 auto 40px', fontSize:'clamp(16px,2vw,20px)', color:'rgba(255,255,255,0.7)', maxWidth:'600px', lineHeight:1.65 }}>
                            Do agendamento ao encerramento, o Evlo garante que cada minuto do seu evento seja executado com perfeição — com automação inteligente e visibilidade total.
                        </p>

                        {/* CTAs */}
                        <div className="lp-hero-btns" style={{ opacity: mounted?1:0, transform: mounted?'translateY(0)':'translateY(24px)', transition:'all 0.6s ease 0.3s', display:'flex', gap:'14px', justifyContent:'center', flexWrap:'wrap' }}>
                            <a href={WHATSAPP} target="_blank" rel="noopener noreferrer" style={{ textDecoration:'none' }}>
                                <button className="lp-btn-primary" style={{ fontSize:'16px', padding:'16px 32px' }}>
                                    <WhatsAppIcon /> Falar pelo WhatsApp
                                </button>
                            </a>
                            <a href="#planos" style={{ textDecoration:'none' }}>
                                <button className="lp-btn-ghost" style={{ fontSize:'15px', padding:'16px 28px' }}>
                                    Ver planos e preços
                                </button>
                            </a>
                        </div>

                        {/* Stats */}
                        <div style={{ opacity: mounted?1:0, transition:'all 0.6s ease 0.5s', marginTop:'64px', display:'flex', gap:'48px', justifyContent:'center', flexWrap:'wrap' }}>
                            {[
                                { value:'100%', label:'Automatizado' },
                                { value:'15s', label:'Atualização' },
                                { value:'5', label:'Perfis de acesso' },
                            ].map(s => (
                                <div key={s.label} style={{ textAlign:'center' }}>
                                    <p style={{ margin:'0 0 4px', fontSize:'clamp(28px,4vw,40px)', fontWeight:900, letterSpacing:'-0.03em', background:'linear-gradient(90deg,#2CCB90,#2DB8E1)', WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent' }}>{s.value}</p>
                                    <p style={{ margin:0, fontSize:'13px', color:'rgba(255,255,255,0.5)', fontWeight:500, textTransform:'uppercase', letterSpacing:'0.06em' }}>{s.label}</p>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Wave */}
                    <div style={{ position:'absolute', bottom:0, left:0, right:0 }}>
                        <svg viewBox="0 0 1440 80" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display:'block', width:'100%' }}>
                            <path d="M0 80L48 74.7C96 69.3 192 58.7 288 53.3C384 48 480 48 576 53.3C672 58.7 768 69.3 864 69.3C960 69.3 1056 58.7 1152 53.3C1248 48 1344 48 1392 48L1440 48V80H0Z" fill="#f8fffe"/>
                        </svg>
                    </div>
                </section>

                {/* ── FUNCIONALIDADES ───────────────────────────────────── */}
                <section id="funcionalidades" style={{ padding:'96px 24px', background:'#f8fffe' }}>
                    <div style={{ maxWidth:'1200px', margin:'0 auto' }}>
                        <div style={{ textAlign:'center', marginBottom:'56px' }}>
                            <span style={{ display:'inline-block', padding:'4px 14px', borderRadius:'100px', background:'rgba(44,203,144,0.1)', border:'1px solid rgba(44,203,144,0.2)', color:'#2CCB90', fontSize:'12px', fontWeight:700, textTransform:'uppercase', letterSpacing:'0.08em', marginBottom:'16px' }}>
                                Funcionalidades
                            </span>
                            <h2 style={{ margin:'0 0 16px', fontSize:'clamp(28px,4vw,42px)', fontWeight:800, color:'#0f172a', letterSpacing:'-0.03em' }}>
                                Tudo que você precisa para executar eventos perfeitos
                            </h2>
                            <p style={{ margin:0, fontSize:'17px', color:'#64748b', maxWidth:'520px', margin:'0 auto', lineHeight:1.6 }}>
                                Uma plataforma completa, do planejamento à execução, com visibilidade em tempo real para toda a equipe.
                            </p>
                        </div>

                        <div className="lp-features-grid" style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:'20px' }}>
                            {FEATURES.map((f, i) => (
                                <div key={i} className="lp-feature-card">
                                    <div style={{ width:'48px', height:'48px', borderRadius:'14px', background:f.bg, border:`1px solid ${f.border}`, display:'flex', alignItems:'center', justifyContent:'center', color:f.color, marginBottom:'18px' }}>
                                        {f.icon}
                                    </div>
                                    <h3 style={{ margin:'0 0 10px', fontSize:'16px', fontWeight:700, color:'#0f172a' }}>{f.title}</h3>
                                    <p style={{ margin:0, fontSize:'14px', color:'#64748b', lineHeight:1.6 }}>{f.desc}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* ── COMO FUNCIONA ─────────────────────────────────────── */}
                <section id="como-funciona" style={{ padding:'80px 24px', background:'#fff' }}>
                    <div style={{ maxWidth:'1200px', margin:'0 auto' }}>
                        <div style={{ textAlign:'center', marginBottom:'56px' }}>
                            <span style={{ display:'inline-block', padding:'4px 14px', borderRadius:'100px', background:'rgba(45,184,225,0.1)', border:'1px solid rgba(45,184,225,0.2)', color:'#2DB8E1', fontSize:'12px', fontWeight:700, textTransform:'uppercase', letterSpacing:'0.08em', marginBottom:'16px' }}>
                                Como funciona
                            </span>
                            <h2 style={{ margin:'0 0 16px', fontSize:'clamp(28px,4vw,42px)', fontWeight:800, color:'#0f172a', letterSpacing:'-0.03em' }}>
                                Simples de configurar, poderoso na execução
                            </h2>
                        </div>

                        <div className="lp-steps-grid" style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:'32px' }}>
                            {STEPS.map((s, i) => (
                                <div key={i} style={{ textAlign:'center', position:'relative' }}>
                                    {i < STEPS.length - 1 && (
                                        <div style={{ position:'absolute', top:'28px', left:'calc(50% + 40px)', right:'-50%', height:'2px', background:'linear-gradient(90deg,#e2e8f0,transparent)', display:'block' }} className="lp-step-line" />
                                    )}
                                    <div style={{ width:'56px', height:'56px', borderRadius:'16px', background:'linear-gradient(135deg,#2CCB90,#2DB8E1)', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 20px', boxShadow:'0 8px 20px rgba(44,203,144,0.3)' }}>
                                        <span style={{ fontSize:'16px', fontWeight:900, color:'#fff', letterSpacing:'-0.02em' }}>{s.num}</span>
                                    </div>
                                    <h3 style={{ margin:'0 0 10px', fontSize:'18px', fontWeight:700, color:'#0f172a' }}>{s.title}</h3>
                                    <p style={{ margin:0, fontSize:'14px', color:'#64748b', lineHeight:1.6, maxWidth:'260px', margin:'0 auto' }}>{s.desc}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* ── PLANOS ────────────────────────────────────────────── */}
                <section id="planos" style={{ padding:'96px 24px', background:'#f8fffe' }}>
                    <div style={{ maxWidth:'1200px', margin:'0 auto' }}>
                        <div style={{ textAlign:'center', marginBottom:'56px' }}>
                            <span style={{ display:'inline-block', padding:'4px 14px', borderRadius:'100px', background:'rgba(124,58,237,0.1)', border:'1px solid rgba(124,58,237,0.2)', color:'#7c3aed', fontSize:'12px', fontWeight:700, textTransform:'uppercase', letterSpacing:'0.08em', marginBottom:'16px' }}>
                                Planos e preços
                            </span>
                            <h2 style={{ margin:'0 0 16px', fontSize:'clamp(28px,4vw,42px)', fontWeight:800, color:'#0f172a', letterSpacing:'-0.03em' }}>
                                Escolha o plano ideal para sua organização
                            </h2>
                            <p style={{ margin:'0 auto', fontSize:'17px', color:'#64748b', maxWidth:'480px', lineHeight:1.6 }}>
                                Todos os planos incluem acesso completo. Quanto maior o compromisso, maior a economia.
                            </p>
                        </div>

                        <div className="lp-plans-grid" style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:'24px', alignItems:'start' }}>
                            {PLANS.map((plan) => (
                                <div key={plan.id} className={`lp-plan-card${plan.highlight ? ' highlight' : ''}`}>
                                    {/* Linha gradiente topo */}
                                    {!plan.highlight && <div style={{ position:'absolute', top:0, left:0, right:0, height:'3px', background:'linear-gradient(90deg,#e2e8f0,#cbd5e1)', borderRadius:'24px 24px 0 0' }} />}
                                    {plan.highlight && <div style={{ position:'absolute', top:0, left:0, right:0, height:'3px', background:'linear-gradient(90deg,#2CCB90,#2DB8E1)', borderRadius:'24px 24px 0 0' }} />}

                                    {/* Badge */}
                                    {plan.badge && (
                                        <div style={{ marginBottom:'16px' }}>
                                            <span style={{ display:'inline-flex', alignItems:'center', gap:'5px', padding:'4px 12px', borderRadius:'100px', background:'linear-gradient(135deg,rgba(44,203,144,0.15),rgba(45,184,225,0.15))', border:'1px solid rgba(44,203,144,0.3)', color:'#16a972', fontSize:'12px', fontWeight:700 }}>
                                                {[1,2,3].map(i => <StarIcon key={i} />)} {plan.badge}
                                            </span>
                                        </div>
                                    )}

                                    <h3 style={{ margin:'0 0 8px', fontSize:'20px', fontWeight:800, color:'#0f172a' }}>{plan.name}</h3>

                                    {/* Preço */}
                                    <div style={{ margin:'20px 0 8px', display:'flex', alignItems:'flex-end', gap:'6px' }}>
                                        <span style={{ fontSize:'13px', fontWeight:600, color:'#94a3b8', lineHeight:2 }}>R$</span>
                                        <span style={{ fontSize:'clamp(40px,5vw,52px)', fontWeight:900, letterSpacing:'-0.04em', color: plan.highlight ? '#0f172a' : '#0f172a', lineHeight:1 }}>{plan.price}</span>
                                    </div>
                                    <p style={{ margin:'0 0 6px', fontSize:'13px', color:'#94a3b8', fontWeight:500 }}>{plan.period}</p>

                                    {plan.saving && (
                                        <p style={{ margin:'0 0 24px', display:'inline-flex', alignItems:'center', gap:'5px', fontSize:'12px', fontWeight:700, color:'#16a972', background:'rgba(44,203,144,0.08)', border:'1px solid rgba(44,203,144,0.2)', padding:'3px 10px', borderRadius:'100px' }}>
                                            <CheckIcon /> {plan.saving}
                                        </p>
                                    )}
                                    {!plan.saving && <div style={{ marginBottom:'24px' }} />}

                                    {/* CTA */}
                                    <button
                                        onClick={() => handleAssinar(plan.id)}
                                        disabled={loadingPlano === plan.id}
                                        style={{
                                            width:'100%', padding:'13px', borderRadius:'12px', border:'none', cursor: loadingPlano === plan.id ? 'not-allowed' : 'pointer', fontSize:'14px', fontWeight:700, fontFamily:'inherit', transition:'all 0.2s', marginBottom:'28px', display:'block',
                                            background: plan.highlight ? 'linear-gradient(135deg,#2CCB90,#2DB8E1)' : '#f8fafc',
                                            color: plan.highlight ? '#fff' : '#0f172a',
                                            border: plan.highlight ? 'none' : '1px solid #e2e8f0',
                                            boxShadow: plan.highlight ? '0 6px 20px rgba(44,203,144,0.3)' : 'none',
                                            opacity: loadingPlano === plan.id ? 0.7 : 1,
                                        }}
                                        onMouseEnter={e => { if (!loadingPlano) { e.currentTarget.style.transform='translateY(-1px)'; e.currentTarget.style.boxShadow = plan.highlight ? '0 10px 28px rgba(44,203,144,0.4)' : '0 4px 12px rgba(0,0,0,0.08)'; } }}
                                        onMouseLeave={e => { e.currentTarget.style.transform=''; e.currentTarget.style.boxShadow = plan.highlight ? '0 6px 20px rgba(44,203,144,0.3)' : 'none'; }}
                                    >
                                        {loadingPlano === plan.id ? 'Aguarde...' : 'Assinar agora'}
                                    </button>

                                    {/* Itens */}
                                    <div style={{ borderTop:'1px solid #f1f5f9', paddingTop:'24px', display:'flex', flexDirection:'column', gap:'12px' }}>
                                        {plan.items.map((item, i) => (
                                            <div key={i} style={{ display:'flex', alignItems:'flex-start', gap:'10px' }}>
                                                <span style={{ width:'20px', height:'20px', borderRadius:'6px', background:'rgba(44,203,144,0.1)', border:'1px solid rgba(44,203,144,0.2)', display:'flex', alignItems:'center', justifyContent:'center', color:'#2CCB90', flexShrink:0, marginTop:'1px' }}>
                                                    <CheckIcon />
                                                </span>
                                                <span style={{ fontSize:'14px', color:'#475569', lineHeight:1.5 }}>{item}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Nota */}
                        <p style={{ textAlign:'center', marginTop:'32px', fontSize:'13px', color:'#94a3b8' }}>
                            Dúvidas sobre qual plano escolher?{' '}
                            <a href={WHATSAPP} target="_blank" rel="noopener noreferrer" style={{ color:'#2CCB90', fontWeight:600, textDecoration:'none' }}>
                                Fale com a gente no WhatsApp
                            </a>{' '}e te ajudamos a decidir.
                        </p>
                    </div>
                </section>

                {/* ── CTA FINAL ─────────────────────────────────────────── */}
                <section style={{ padding:'96px 24px', background:'linear-gradient(135deg, #0E2C52 0%, #0a4a5e 100%)', position:'relative', overflow:'hidden' }}>
                    <div style={{ position:'absolute', inset:0, pointerEvents:'none' }}>
                        <div style={{ position:'absolute', top:'-20%', left:'10%', width:'500px', height:'500px', borderRadius:'50%', background:'radial-gradient(circle,rgba(44,203,144,0.12) 0%,transparent 65%)', filter:'blur(60px)' }} />
                        <div style={{ position:'absolute', bottom:'-20%', right:'10%', width:'500px', height:'500px', borderRadius:'50%', background:'radial-gradient(circle,rgba(45,184,225,0.1) 0%,transparent 65%)', filter:'blur(60px)' }} />
                    </div>
                    <div style={{ position:'relative', zIndex:1, maxWidth:'700px', margin:'0 auto', textAlign:'center' }}>
                        <h2 style={{ margin:'0 0 20px', fontSize:'clamp(28px,4vw,44px)', fontWeight:900, letterSpacing:'-0.03em', color:'#fff', lineHeight:1.15 }}>
                            Pronto para executar eventos com mais controle?
                        </h2>
                        <p style={{ margin:'0 0 40px', fontSize:'17px', color:'rgba(255,255,255,0.65)', lineHeight:1.65 }}>
                            Fale com nossa equipe agora mesmo pelo WhatsApp e comece a usar em minutos.
                        </p>
                        <a href={WHATSAPP} target="_blank" rel="noopener noreferrer" style={{ textDecoration:'none' }}>
                            <button className="lp-btn-primary" style={{ fontSize:'17px', padding:'18px 40px' }}>
                                <WhatsAppIcon /> Falar com a equipe <ArrowRightIcon />
                            </button>
                        </a>
                    </div>
                </section>

                {/* ── FOOTER ────────────────────────────────────────────── */}
                <footer style={{ background:'#0a1628', padding:'40px 24px' }}>
                    <div style={{ maxWidth:'1200px', margin:'0 auto', display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:'16px' }}>
                        <div style={{ display:'inline-flex', alignItems:'center', background:'#fff', borderRadius:'10px', padding:'5px 14px', border:'1px solid rgba(255,255,255,0.15)' }}>
                            <img src="/logo-horizontal.png" alt="Evlo" style={{ height:'22px', objectFit:'contain' }} onError={e => { e.target.style.display='none'; e.target.parentNode.innerHTML='<span style="font-size:18px;font-weight:800;color:#0E2C52;letter-spacing:-0.03em">evlo</span>'; }} />
                        </div>
                        <p style={{ margin:0, fontSize:'13px', color:'rgba(255,255,255,0.3)' }}>
                            © {new Date().getFullYear()} Evlo. Todos os direitos reservados.
                        </p>
                        <button onClick={() => navigate('/login')} style={{ background:'none', border:'1px solid rgba(255,255,255,0.15)', borderRadius:'8px', color:'rgba(255,255,255,0.5)', fontSize:'13px', padding:'7px 16px', cursor:'pointer', fontFamily:'inherit', transition:'all 0.15s' }}
                            onMouseEnter={e => e.currentTarget.style.color='rgba(255,255,255,0.9)'}
                            onMouseLeave={e => e.currentTarget.style.color='rgba(255,255,255,0.5)'}>
                            Acessar plataforma
                        </button>
                    </div>
                </footer>

            </div>
        </>
    );
};

export default LandingPage;
